var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('drop-list',{attrs:{"items":_vm.tarefasComputadas},on:{"reorder":function($event){return $event.apply(_vm.tarefasComputadas)}},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var reorder = ref.reorder;
return [_c('drag',{key:item.id,attrs:{"data":item}},[_c('Tarefa',{staticStyle:{"background-color":"white"},style:(reorder ? {borderLeft: '2px solid #1976D2', marginLeft:'-2px'} : {}),attrs:{"tarefa":item}}),_c('v-divider')],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }